export interface DeploymentRecord {
  id: string;
  version: string;
  commitSha: string;
  deployedAt: string;
  status: 'SUCCESS' | 'FAILED' | 'ROLLBACK';
  author: string;
  durationMs: number;
}

export interface BackupRecord {
  id: string;
  type: 'LOGICAL' | 'PHYSICAL_BASE' | 'WAL_ARCHIVE';
  startedAt: string;
  completedAt: string;
  sizeMb: number;
  status: 'SUCCESS' | 'FAILED';
  isOffsite: boolean;
  encryption: boolean;
  restoredTested: boolean;
}

export interface SLOMetric {
  id: string;
  name: string;
  targetPct: number;
  actualPct: number;
  status: 'HEALTHY' | 'AT_RISK' | 'VIOLATED';
  windowDays: number;
}

export interface CostCategory {
  id: string;
  name: string;
  estimatedMonthlyUsd: number;
  trendPct: number;
}

export const MOCK_DEPLOYMENTS: DeploymentRecord[] = [
  { id: 'dep-104', version: 'v1.4.2', commitSha: 'a8f93e2', deployedAt: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(), status: 'SUCCESS', author: 'CI/CD Pipeline', durationMs: 45000 },
  { id: 'dep-103', version: 'v1.4.1', commitSha: 'b27d4c1', deployedAt: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString(), status: 'ROLLBACK', author: 'SRE Automation', durationMs: 38000 },
  { id: 'dep-102', version: 'v1.4.0', commitSha: '9f8e7d6', deployedAt: new Date(Date.now() - 1000 * 60 * 60 * 72).toISOString(), status: 'SUCCESS', author: 'CI/CD Pipeline', durationMs: 51000 },
];

export const MOCK_BACKUPS: BackupRecord[] = [
  { id: 'bkp-883', type: 'LOGICAL', startedAt: new Date(Date.now() - 1000 * 60 * 60 * 4).toISOString(), completedAt: new Date(Date.now() - 1000 * 60 * 60 * 3.9).toISOString(), sizeMb: 204.5, status: 'SUCCESS', isOffsite: true, encryption: true, restoredTested: false },
  { id: 'bkp-882', type: 'PHYSICAL_BASE', startedAt: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(), completedAt: new Date(Date.now() - 1000 * 60 * 60 * 23.5).toISOString(), sizeMb: 1450.2, status: 'SUCCESS', isOffsite: true, encryption: true, restoredTested: true },
  { id: 'bkp-881', type: 'LOGICAL', startedAt: new Date(Date.now() - 1000 * 60 * 60 * 28).toISOString(), completedAt: new Date(Date.now() - 1000 * 60 * 60 * 27.9).toISOString(), sizeMb: 201.1, status: 'SUCCESS', isOffsite: true, encryption: true, restoredTested: false },
];

export const MOCK_SLOS: SLOMetric[] = [
  { id: 'slo-1', name: 'Global API Availability', targetPct: 99.9, actualPct: 99.95, status: 'HEALTHY', windowDays: 30 },
  { id: 'slo-2', name: 'Calculator Engine Success Rate', targetPct: 99.99, actualPct: 99.99, status: 'HEALTHY', windowDays: 30 },
  { id: 'slo-3', name: 'P95 Web Latency < 300ms', targetPct: 95.0, actualPct: 92.4, status: 'VIOLATED', windowDays: 30 },
  { id: 'slo-4', name: 'Queue Processing Latency < 5s', targetPct: 99.0, actualPct: 99.2, status: 'AT_RISK', windowDays: 30 },
];

export const MOCK_COSTS: CostCategory[] = [
  { id: 'cst-1', name: 'Hostinger VPS Infrastructure', estimatedMonthlyUsd: 49.99, trendPct: 0 },
  { id: 'cst-2', name: 'Cloudflare / Edge CDN', estimatedMonthlyUsd: 25.00, trendPct: 0 },
  { id: 'cst-3', name: 'OpenAI / Gemini API', estimatedMonthlyUsd: 340.50, trendPct: 15.2 },
  { id: 'cst-4', name: 'Object Storage (Backblaze B2)', estimatedMonthlyUsd: 12.40, trendPct: 2.1 },
  { id: 'cst-5', name: 'External Data Providers (FX/Tax)', estimatedMonthlyUsd: 185.00, trendPct: 0 },
];

export const INFRA_HEALTH = {
  overall: 'DEGRADED_HA',
  spof: ['Hostinger VPS Node', 'Single PostgreSQL Instance', 'Dokploy Control Plane'],
  postgres: {
    version: '16.4-alpine',
    connections: 42,
    maxConnections: 200,
    cpuUsagePct: 18,
    diskUsageGb: 4.2,
    diskTotalGb: 100,
  },
  redis: {
    version: '7.2.5-alpine',
    memoryUsageMb: 145,
    memoryTotalMb: 2048,
    connectedClients: 12,
  },
  vps: {
    cpuUsagePct: 45,
    memoryUsageGb: 12.4,
    memoryTotalGb: 32,
    diskUsageGb: 45,
    diskTotalGb: 400,
  },
};
